import React, { ReactElement } from "react";
import styles from "./footer.module.scss";

export const Footer = (props: Props): ReactElement => {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.columnWrapper}>
          <div className={styles.column}>{props.firstColumnLinks}</div>
          <div className={styles.column}>{props.secondColumnLinks}</div>
        </div>
        <div className={styles.columnWrapper}>
          <div className={styles.column}>{props.thirdColumnLinks}</div>
          <div className={styles.column}>{props.forthColumnLinks}</div>
        </div>
      </div>
      {props.affix}
    </footer>
  );
};

interface Props {
  firstColumnLinks?: JSX.Element;
  secondColumnLinks?: JSX.Element;
  thirdColumnLinks?: JSX.Element;
  forthColumnLinks?: JSX.Element;
  affix?: JSX.Element;
}
